import { checkEmail } from 'api/user';
import { useQuery } from '@tanstack/react-query';

// Inspired from https://github.com/ReceiptProphet/delphi-rn-client/blob/main/src/hooks/useCheckEmail.ts


type CheckEmailResult = {
  emailFound: boolean;
};

export default function useEmailChecker(email: string) {
  const queryResponse = useQuery<CheckEmailResult>(
    ['emailCheck', email],
    async () => await checkEmail(email),
    {
      enabled: !!email,
      onError: (err) => {
        console.error('Error checking email: ', err);
      },
    }
  );

  return {
    checkEmail: queryResponse.data?.emailFound,
    checkEmailLoading: queryResponse.isLoading,
    checkEmailError: queryResponse.isError,
    fetching: queryResponse.isFetching,
  };
}
